import TemplatesCtrl from './controllers/index';
import TemplateCreateCtrl from './controllers/create';
import TemplateEditCtrl from './controllers/edit';
import OrderCtrl from './controllers/order';
import templateBlockSettings from './directives/template-block-settings';
import templateImagesBlockPart from './directives/template-images-block-part';
import templateImagesBlock from './directives/template-images-block';
import footerTemplate from "./directives/footer-template";
import Template from './template.repository';
import routing from './template.routes';
import uirouter from 'angular-ui-router';

export default angular.module('app.templates', [uirouter])
    .config(routing)
    .controller('TemplatesCtrl', TemplatesCtrl)
    .controller('TemplateCreateCtrl', TemplateCreateCtrl)
    .controller('TemplateEditCtrl', TemplateEditCtrl)
    .controller('OrderCtrl', OrderCtrl)
    .directive('templateBlockSettings', () => new templateBlockSettings)
    .directive('templateImagesBlock', () => new templateImagesBlock)
    .directive('templateImagesBlockPart', () => new templateImagesBlockPart)
    .directive('footerTemplate', () => new footerTemplate)
    .service('Template', Template)
    .name;